(function ($) {
  $(document).ready(function () {

    let _nextScrollPoint = 0;//インフィニティスクロールが始まる位置
    let _isLoading = false;//読み込み中フラグ
    let _$next = $('.js-pager .next');//次のページの URL を持つリンク
    let _watingItems = [];//読み込んだ記事の一覧
    let _yearItems = [];
    let _yearStrTop = 0;
    let _startYear = Number($('.js-year-item:eq(0)').attr('data-year'));
    var _$yearPut = $('#js-cyear');
    var _isYear = document.getElementById('js-cyear');
    var _$yStop = $('#js-y-stop');
    var _yStopTop = 0;//年の追従が止まる位置
    var _winH = $(window).height();//ウィンドウの高さ

    function setYStopTop() {
      if(_$yStop.length > 0) {
        _yStopTop = _$yStop.offset().top + _$yStop.height();
        // $('#aa').css('top', _yStopTop + 'px');
      }
    }

    function initPos() {
      setWatinItemPos();
      setNextScrollPoint();
      setYStopTop();
      _winH = $(window).height()

      if(_isYear) {
        setYearStrTop();
        setYearItemPos();
      }
    }

    function setNextScrollPoint() {//インフィニティスクロールが始まる位置を設定
      const $el = $('.js-infinity-wrap .js-infinity-item:last');
      const top = $el.offset().top;
      const h = $(window).height();
      _nextScrollPoint = top - h;
    }

    function setWatinItemPos() {
      _watingItems.forEach(function($v, i) {
        $v.data({
          'top': $v.offset().top - ( $(window).height() * .8 )
        });
      });
    }

    function setYearStrTop() {
      if( $('.u-hidden-gtTAB').css('display') !== 'none' ) {
        _yearStrTop = parseInt($('#js-cyear').css('top')) + $(window).width() * .7;
      } else {
        //pc
        _yearStrTop = $(window).height() * .9;
      }
      // $('#aa').css('top', _yearStrTop + 'px');
    }

    function setYearItemPos() {
      _yearItems = $('.js-year-item');
      _yearItems.each(function(e) {
        $(this).data({
          'ytop': $(this).offset().top
        });
      });
    }

    function yearHandle(scTop) {
      let $yoriUeEl = [];
      let minYear = _startYear;
      //敷居値よりを小さいか
      _yearItems.each(function(e) {
        let myTop = $(this).data('ytop');
        if((myTop - scTop) <= _yearStrTop) {
          $yoriUeEl.push($(this));
        }
      });
      //敷居値よりを小さい物の中で一番年数の古いもの
      $yoriUeEl.forEach(function(v, i) {
        const myYear = Number($(v).attr('data-year'));
        if( myYear < minYear) {
          minYear = myYear;
        }
      });
      _$yearPut.text(minYear);
    }

    function refreshWatinItemPos() {
      //出現したものは配列から削除
      let deleteNumbres = [];
      _watingItems.forEach(function($v, i) {
        if( $v.hasClass('is-fire') ) {
          deleteNumbres.push(i);
        }
      });
      deleteNumbres = deleteNumbres.reverse();
      deleteNumbres.forEach(function(v, i) {
        _watingItems.splice(v, 1);
      });
    }

    function getNextArticles() {//次のページの記事を取得
      if(_$next.length > 0) {
        const nextURL = _$next.attr('href');
        $.ajax({
          url: nextURL,
        }).done(function(data) {
          let $items = $(data).find('.js-infinity-wrap .js-infinity-item');
          _$next = $(data).find('.js-pager .next');

          $items.each(function(i, v) {
            $v = $(v);
            $v.addClass('is-transition');
            $('.js-infinity-wrap').append($v);
            _watingItems.push($v);
          });

          setWatinItemPos();
          setNextScrollPoint();
          refreshWatinItemPos();
          setYearItemPos();
          setYStopTop();
          _isLoading = false;
        });
      }
    }

    initPos();

    $(window).on('scroll', function(e) {
      let scTop = $(window).scrollTop();
      let scrollBottom = scTop + $(window).height();

      _watingItems.forEach(function ($v, i) {
        if (scTop >= $v.data('top')) {
          $v.addClass('is-fire');
        }
      });

      if(scrollBottom > _nextScrollPoint) {
        if(!_isLoading) {
          _isLoading = true;
          getNextArticles();
        }
      }

      if(_isYear) {
        console.log("y");
        yearHandle(scTop);
        if(scTop >= _yStopTop - _winH) {
          _isYear.style.marginRight = parseInt($('.c-archive--pj').css('margin-right')) * -1 + 'px';
          _isYear.classList.add('is-end');

        } else {
          _isYear.style.marginRight = '0';
          _isYear.classList.remove('is-end');
        }
      }

    });

    $(window).on('resize', initPos);

  });

})(jQuery);
